export default {
  biShiftsBySite: 'BI_SHIFTS_BY_SITE',
  biShiftsByEmployee: 'BI_SHIFTS_BY_EMPLOYEE',
  biShiftsByMobilePatrol: 'BI_SHIFTS_BY_MOBILE_PATROL',
  biShiftsDetailed: 'BI_SHIFTS_DETAILED',
  setLoadingState: 'BI_SHIFTS_SET_LOADING_STATE',
};
